import { EntityModel } from '@/interfaces'
import {
  ALL_EXTENSION_ACCOMMODATIONS_QUERY,
  CREATE_EXTENSION_ACCOMMODATION_MUTATION,
  DELETE_EXTENSION_ACCOMMODATION_MUTATION,
  FORCE_DELETE_EXTENSION_ACCOMMODATION_MUTATION,
  SINGLE_EXTENSION_ACCOMMODATION_QUERY,
  UPDATE_EXTENSION_ACCOMMODATION_MUTATION,
} from './graphql'

const ratioExtensionAccommodationModel: EntityModel = {
  name: 'extensionAccommodation',
  namePlural: 'extensionAccommodations',
  uniqueName: 'ratioExtensionAccommodation',
  uniqueNamePlural: 'ratioExtensionAccommodations',
  path: 'travel/pricing/adaptors/ratio/extension_accommodation',
  baseUrl: '/travel/pricing/adaptors/ratio/extension_accommodations',
  translationPrefix: 'entities:ratioExtensionAccommodation.',
  getDisplayName: (values: any) => {
    return values.label
  },
  gql: {
    getAll: ALL_EXTENSION_ACCOMMODATIONS_QUERY,
    getSingle: SINGLE_EXTENSION_ACCOMMODATION_QUERY,
    create: CREATE_EXTENSION_ACCOMMODATION_MUTATION,
    update: UPDATE_EXTENSION_ACCOMMODATION_MUTATION,
    delete: DELETE_EXTENSION_ACCOMMODATION_MUTATION,
    forceDelete: FORCE_DELETE_EXTENSION_ACCOMMODATION_MUTATION,
  },
  attributes: {
    ratioPackageNo: {
      name: 'ratioPackageNo',
      label: 'entities:ratioExtensionAccommodation.attributes.ratioPackageNo.label',
      type: 'value',
      dataType: 'number',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    name: {
      name: 'name',
      label: 'entities:ratioExtensionAccommodation.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    label: {
      name: 'label',
      label: 'entities:ratioExtensionAccommodation.attributes.label.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    info: {
      name: 'info',
      label: 'entities:ratioExtensionAccommodation.attributes.info.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      maxLength: 255,
      validationType: 'string',
      validations: [],
    },
    extensionAccommodationServiceNo: {
      name: 'extensionAccommodationServiceNo',
      label: 'entities:ratioExtensionAccommodation.attributes.extensionAccommodationServiceNo.label',
      type: 'value',
      dataType: 'number',
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default ratioExtensionAccommodationModel
